import Immutable from 'immutable';
import reducerCreator from '../../tools/reducer-creator';
import * as types from '../../actions/vacancies/types';

const initialState = Immutable.fromJS({
  isVacancyDuplicationFormDataLoading: false,
  duplicatedVacancy: null,
  duplicatedVacancyHasBeenPosted: false,
  notHiredApplicationsToInvite: null,
  duplicatedVacancyReferenceData: {
    schoolId: undefined,
    vacancyId: undefined
  }
});

export default reducerCreator(initialState, {
  [types.VACANCY_SET_VACANCY_DUPLICATION_FORM_DATA_LOADING]: (state, { isVacancyDuplicationFormDataLoading }) =>
    state.set('isVacancyDuplicationFormDataLoading', isVacancyDuplicationFormDataLoading),

  [types.VACANCY_SET_DUPLICATED_VACANCY]: (state, { duplicatedVacancy }) => 
    state.set('duplicatedVacancy', duplicatedVacancy),

  [types.VACANCY_SET_DUPLICATED_VACANCY_HAS_BEEN_POSTED]: (state, { duplicatedVacancyHasBeenPosted }) =>
    state.set('duplicatedVacancyHasBeenPosted', duplicatedVacancyHasBeenPosted),

  [types.VACANCY_SET_NOT_HIRED_APPLICATIONS_TO_INVITE_TO_DUPLICATED_VACANCY]: (state, { notHiredApplicationsToInvite }) =>
    state.set('notHiredApplicationsToInvite', notHiredApplicationsToInvite),

  [types.VACANCY_SET_DUPLICATED_VACANCY_REFERENCE_DATA]: (state, { schoolId, vacancyId }) => {
    state = state.setIn(['duplicatedVacancyReferenceData', 'schoolId'], schoolId);
    state = state.setIn(['duplicatedVacancyReferenceData', 'vacancyId'], vacancyId);
    return state;
  },

  [types.VACANCY_RESET_VACANCY_DUPLICATION_STATE]: () =>
    initialState
});



// WEBPACK FOOTER //
// ./src/reducers/vacancies/vacancy-duplication.js